import React from 'react';

export default function AGB(){
  return (
    <div style={{padding:'60px 6%'}}>
      <h2 className="title">Allgemeine Geschäftsbedingungen (AGB)</h2>
      <p>1. Geltungsbereich: Diese AGB regeln die Leistungen von Liberty Street Food GmbH...</p>
      <p>2. Leistungen: Unsere Cateringleistungen werden individuell vereinbart...</p>
      <p>3. Preise und Zahlung: Preise verstehen sich zzgl. gesetzlicher MwSt...</p>
      <p>4. Stornierungen: Bei Absagen gelten folgende Bedingungen...</p>
      <p>5. Haftung: Unsere Haftung ist insbesondere für Vorsatz und grobe Fahrlässigkeit ausgeschlossen...</p>
      <p>--- (Dies ist ein Platzhaltertext; bitte rechtlich prüfen lassen.)</p>
    </div>
  );
}
